
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { logStore } from '@/store';

@Component
export default class LogShowComponent extends Vue {
  @Prop(Number) readonly propModelId;
  @Prop(String) readonly propModel;
  @Prop({ type: Object, default: () => {} }) readonly propFilters;

  @Watch('propModelId')
  async onUpdateId(val) {
    this.id = val;
    let params = {
      model: this.propModel,
      modelId: this.id,
      filters: this.propFilters,
    };
    this.log = await logStore.getLog(params);
    this.loading = false;
  }

  public loading = true;

  public id: number = 0;

  public log = [];

  public dialog = false;

  public operationsHeaders = [
    {
      text: 'Usuário',
      sortable: true,
      value: 'created_by_name',
      align: 'left',
    },
    {
      text: 'Data',
      sortable: true,
      value: 'created_at',
      align: 'left',
    },
    {
      text: 'Ações',
      value: 'actions',
    },
  ];

  public operationsItems = [];

  public detailsHeaders = [
    {
      text: 'Campo',
      sortable: true,
      value: 'field',
      align: 'left',
    },
    {
      text: 'Antes',
      sortable: true,
      value: 'before',
      align: 'left',
    },
    {
      text: 'Depois',
      sortable: true,
      value: 'after',
      align: 'left',
    },
  ];

  public detailsItems = [];

  public async show() {
    this.dialog = true;
  }

  public async showDetail(index) {
    this.detailsItems = [];
    //@ts-ignore
    Object.keys(this.log[index].data).forEach((key) => {
      let beforeValue = '';
      if (index <= 0) {
        beforeValue = '';
      } else {
        //@ts-ignore
        if (!_.isNil(this.log[index - 1].data[key])) {
          //@ts-ignore
          beforeValue = this.log[index - 1].data[key];
        }
      }

      let afterValue = '';
      //@ts-ignore
      if (!_.isNil(this.log[index].data[key])) {
        //@ts-ignore
        afterValue = this.log[index].data[key];
      }

      if (beforeValue != afterValue) {
        this.detailsItems.push({
          //@ts-ignore
          field: key,
          //@ts-ignore
          before: beforeValue,
          //@ts-ignore
          after: afterValue,
        });
      }
    });
  }
}
